<ng-container *ngIf="successFieldValidations$ | async as successMessages">
  <ng-container *ngIf="formGroup$ | async as formGroup">
    <ng-container *ngIf="fieldStructure$ | async as fieldsStructure">
      <div
        class="form-container"
        *ngFor="let row of fieldsStructure; trackBy: trackByStructure"
      >
        <!-- Get fields value-->
        <ng-container *ngIf="row.fields as fields">
          <!--render inputs in a template-->
          <div class="d-flex">
            <ng-container
              *ngFor="
                let rowFieldsEntry of fields;
                trackBy: trackByFieldSettings;
                let rowFieldEntryIndex = index
              "
            >
              <!-- set field as value-->
              <ng-container *ngIf="rowFieldsEntry.field as field">
                <!-- check depends on -->
                <div
                  *ngIf="rowFieldsEntry.show$ | async"
                  class="grow1 input-field input-field-{{ field.type }}"
                  [ngClass]="
                    field['grid-col-width']
                      ? 'grow' + field['grid-col-width']
                      : null
                  "
                >
                  <!-- dont hide elements without no postname data -->
                  <ng-container
                    *ngIf="
                      field.postname ||
                      'no-postname-parameter-' + rowFieldEntryIndex as inputId
                    "
                  >
                    <orderform-generator-input
                      [inputId]="inputId"
                      [field]="field"
                      [formGroupRef]="formGroup"
                    ></orderform-generator-input>

                    <div *ngIf="field.hint" class="mt-2 text-muted">
                      {{ field.hint }}
                    </div>
                  </ng-container>
                </div>
              </ng-container>
            </ng-container>
          </div>

          <!-- show messages items seperated from inputs because
           some inputs can be tiny -->
          <div class="d-flex">
            <ng-container
              *ngFor="
                let rowFieldsEntry of fields;
                trackBy: trackByFieldSettings
              "
            >
              <div class="grow1">
                <ng-container *var="rowFieldsEntry.field as field">
                  <div
                    class="success-message"
                    *ngIf="successMessages[field.postname] as successMessage"
                  >
                    {{ successMessage }}
                  </div>

                  <orderform-input-errors
                    [fieldName]="field.label !== 'skip' ? field.label : ''"
                    [regexMessage]="
                      field.regex_message?.replace('[LABEL]', field.label)
                    "
                    [control]="formGroup.controls[field.postname]"
                  ></orderform-input-errors>
                </ng-container>
              </div>
            </ng-container>
          </div>
        </ng-container>
      </div>
    </ng-container>
  </ng-container>
</ng-container>
